import { Link } from "react-router-dom";
import { companyDetails, legalDocuments } from "./documents";

/**
 * The statutory line and the way to every legal document.
 *
 * The Companies (Trading Disclosures) Regulations 2008 and the Electronic Commerce Regulations
 * 2002 require the company's name, registered number, place of registration and registered
 * office on its website, and CalOPPA requires a conspicuous link to the privacy notice from the
 * pages that collect personal information. Both are met once here and reused, so no public
 * page can quietly lose them.
 */
export function LegalFooter({ className = "legal-footer" }: { className?: string }) {
  return (
    <footer className={className}>
      <p>
        {companyDetails.legalName}, trading as {companyDetails.tradingName}, is a private limited
        company registered in {companyDetails.registeredIn}, company registration number{" "}
        {companyDetails.companyNumber}. Registered office: {companyDetails.registeredOffice}.
      </p>
      <nav aria-label="Legal">
        {legalDocuments.map((item) => (
          <Link key={item.slug} to={`/legal/${item.slug}`}>
            {item.shortTitle}
          </Link>
        ))}
      </nav>
    </footer>
  );
}

/**
 * The short form for the sign-in and recovery pages: the legal name and the two documents an
 * account holder is bound by. It sits under the card rather than in the brand panel, because a
 * phone shows that panel as a short strip above the card, and anything kept there would leave the
 * smallest screens without a way to the privacy notice.
 */
export function LegalLine({ className = "legal-line" }: { className?: string }) {
  return (
    <footer className={className}>
      {companyDetails.legalName} · <Link to="/legal/privacy">Privacy</Link> ·{" "}
      <Link to="/legal/terms">Terms</Link>
    </footer>
  );
}
